<y42-icon *ngIf="iconName" [icon]="iconName" class="empty-state-icon"></y42-icon>
<div *ngIf="header">{{ header }}</div>
<div *ngIf="body">
  {{ body }}
</div>

<ng-container *ngIf="state.addButtonLabelTemplate; else defaultButtonTmpl">
  <ng-container [ngTemplateOutlet]="state.addButtonLabelTemplate"></ng-container>
</ng-container>

<ng-template #defaultButtonTmpl>
  <button *ngIf="addButtonLabel" mat-flat-button type="button" (click)="add.emit()">
    {{ addButtonLabel }}
  </button>
</ng-template>
